import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const FullWidthImage = props => (
    <StaticQuery
      query={graphql`
        query {
            images: allFile(filter: { sourceInstanceName: { eq: "images" } }) {
                edges {
                    node {
                        relativePath
                        childImageSharp {
                            fluid(maxWidth : 992) {
                                ...GatsbyImageSharpFluid_noBase64
                            }
                        }
                    }
                }
            }
        }
    `}
      render={data => {
            const image = data.images.edges.find(n => {
            return n.node.relativePath.includes(props.src);
        });
        if (!image) {
          return null;
        }
  
        return <Img alt={props.alt} fluid={image.node.childImageSharp.fluid} fadeIn={true} />;
      }}
    />
  );
  
  export default FullWidthImage;